module.exports = __webpack_public_path__ + "files/e243ce4c79983637225c0bb55f4d59c3.png";